import React from 'react';
import { Container } from '@/components/index';
import { Box, Paper, Typography } from '@mui/material';
import { setDocTitle } from '@/src/components/documentTitleHook';
import { ERROR_500_PAGE_TITLE } from '@/src/static';

export const Error500: React.FC = () => {
  setDocTitle(ERROR_500_PAGE_TITLE);
  return (
    <Container>
      <Box className="generalMessage flex flex-col">
        <img className="mx-auto mt-14" src="/icons/SSHE-logo.svg" alt="pankod" height="58" />
        <Paper elevation={4} className="w-full text-center block mx-auto mt-14 p-12" sx={{ maxWidth: '700px' }}>
          <img className="mx-auto" src="/icons/error500.svg" alt="pankod" height="94" width="84" />
          <Typography className="mt-8" variant="h2">
            Sorry, this is not working properly.
          </Typography>
          <Typography className="mt-4" variant="h6">
            We now know about this mistake and are woking to fix it.
          </Typography>
          {/* <Button className="mt-8 w-28" variant="outlined">
            Close
          </Button> */}
        </Paper>
      </Box>
    </Container>
  );
};
